import PageLoader from "@components/PageLoader";
import React, { createContext, useContext, useState, useEffect } from "react";

export enum Role {
  Admin = "admin",
  User = "user",
}

interface AuthContextType {
  isAuthenticated: boolean;
  role: Role | null;
  login: (role: Role, token: string, name: string) => void;
  logout: () => void;
  name: string | null;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [role, setRole] = useState<Role | null>(null);
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState<string | null>(null);

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      setIsAuthenticated(true);
      const savedRole = localStorage.getItem("role");
      setRole(savedRole as Role);

      const savedName = localStorage.getItem("name");
      setName(savedName);
    }

    setLoading(false);
  }, []);

  const login = (userRole: Role, token: string, name: string) => {
    setIsAuthenticated(true);
    setRole(userRole);
    setName(name);
    localStorage.setItem("token", token);
    localStorage.setItem("role", userRole);
    localStorage.setItem("name", name);
  };

  const logout = () => {
    setIsAuthenticated(false);
    setRole(null);
    setName(null);
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("name");
  };

  if (loading) {
    return <PageLoader />;
  }
  return (
    <AuthContext.Provider
      value={{ isAuthenticated, role, login, logout, name }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
